import CustomSkillPane from './CustomSkillPane';

export default CustomSkillPane;
export { CustomSkillPane };
